










































































































import {getSize, isBrowser, isEmpty, isFunction, isUndefined, PlainObject} from '@labor-digital/helferlein';
import {Component, Vue, Watch} from 'vue-property-decorator';
import VuFormInputAbstract from './VuFormInputAbstract.vue';

@Component
export default class VuFormInputTemplate extends Vue
{
    /**
     * True when the field is in focus
     * @protected
     */
    protected hasFocus: boolean = false;

    /**
     * Holds the field min width when we show the virtual placeholder
     * @protected
     */
    protected minWith: number = 0;

    get hasLabel(): boolean
    {
        return isFunction(this.$scopedSlots.default) && !isEmpty(this.$scopedSlots.default({}));
    }

    get isEmpty(): boolean
    {
        return isEmpty(this.p._value);
    }

    get p(): VuFormInputAbstract
    {
        return this.$parent as any;
    }

    get classes(): PlainObject
    {
        return {
            'vuFormInput--required': this.p.required,
            'vuFormInput--disabled': this.p.disabled,
            'vuFormInput--readonly': this.p.readOnly,
            'vuFormInput--focus': this.hasFocus,
            'vuFormInput--invalid': !this.p.isValid,
            'vuFormInput--withLabel': this.hasLabel,
            'vuFormInput--empty': this.isEmpty,
            ['vuFormInput--' + this.p.type]: true
        };
    }

    get fieldStyle(): PlainObject
    {
        return {
            color: this.showVirtualPlaceholder ? 'transparent' : null,
            minWidth: this.minWith === 0 ? null : this.minWith + 'px'
        };
    }

    get showVirtualPlaceholder(): boolean
    {
        return !this.hasFocus && this.isEmpty && !isEmpty(this.p.placeholder) &&
               ['date', 'time'].indexOf(this.p.type) !== -1;
    }

    protected onBlur()
    {
        this.hasFocus = false;
        this.p._triggerProcessing('blur');
        this.p.$emit('blur');
    }

    protected onFocus()
    {
        this.hasFocus = true;
        this.p._triggerProcessing('focus');
        this.p.$emit('focus');
    }

    protected onClearClick(): void
    {
        this.p._value = null;
        this.p.$emit('clear');
    }

    @Watch('showVirtualPlaceholder')
    public watchShowVirtualPlaceHolder(n): void
    {
        if (!n) {
            this.minWith = 0;
        } else {
            this.$nextTick(() => {
                if (isBrowser() && !isUndefined(this.$refs.virtualPlaceholder)) {
                    this.minWith = getSize(this.$refs.virtualPlaceholder as HTMLElement).width;
                }
            });
        }
    }
}
